// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEnumTypeDto
 */
export interface IEnumTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IEnumTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEnumTypeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEnumTypeDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IEnumTypeDto interface.
 */
export function instanceOfIEnumTypeDto(value: object): value is IEnumTypeDto {
    return true;
}

export function IEnumTypeDtoFromJSON(json: any): IEnumTypeDto {
    return IEnumTypeDtoFromJSONTyped(json, false);
}

export function IEnumTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEnumTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IEnumTypeDtoToJSON(json: any): IEnumTypeDto {
    return IEnumTypeDtoToJSONTyped(json, false);
}

export function IEnumTypeDtoToJSONTyped(value?: IEnumTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

